import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Newspaper } from 'lucide-react';
import { supabase } from '@/integrations/supabase/client';
import { formatDateShort } from '@/lib/formatters';

interface Post {
  id: string;
  title: string;
  slug: string;
  published_at: string | null;
}

export function FooterLatestNews() {
  const [posts, setPosts] = useState<Post[]>([]);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      const { data } = await supabase
        .from('news_posts')
        .select('id, title, slug, published_at')
        .eq('is_published', true)
        .order('published_at', { ascending: false })
        .limit(3);
      if (!cancelled) setPosts((data as Post[]) || []);
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <div className="col-span-2 md:col-span-3 lg:col-span-1">
      <h4 className="font-semibold mb-3 sm:mb-4 flex items-center gap-1.5">
        <Newspaper className="w-4 h-4 text-accent" /> Seneste nyheder
      </h4>
      {posts.length === 0 ? (
        <p className="text-sm text-primary-foreground/60">Ingen nyheder endnu.</p>
      ) : (
        <ul className="space-y-3 text-sm">
          {posts.map((p) => (
            <li key={p.id}>
              <Link
                to={`/nyheder/${p.slug}`}
                className="text-primary-foreground/80 hover:text-accent transition-colors line-clamp-2 leading-snug block"
              >
                {p.title}
              </Link>
              {p.published_at && (
                <span className="text-[11px] text-primary-foreground/50">
                  {formatDateShort(p.published_at)}
                </span>
              )}
            </li>
          ))}
        </ul>
      )}
      <Link
        to="/nyheder"
        className="text-sm text-accent hover:underline inline-block mt-3"
      >
        Alle nyheder →
      </Link>
    </div>
  );
}
